import { AppSettings } from '@/appSettings'
import { BLIP_DOMAIN } from '../settings'

export class TenantService {
  static _enabled: boolean

  static isTenantWebsocketEnabled() {
    if (this._enabled !== undefined) {
      return this._enabled
    }

    this._enabled = AppSettings.get('ENABLE_ORGANIZATION_WEBSOCKET_CONNECTION') === 'true'

    return this._enabled
  }

  static getTenantFromHost(hostname: string) {
    if (this.isTenantWebsocketEnabled()) {
      const address = hostname.replace(`.${BLIP_DOMAIN}`, '').split('.')

      return address.length >= 2 ? address[0] : undefined
    } else {
      return undefined
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/TenantService.ts